module.exports = "<svg style=\"width: 16px; height: 10px;\" viewBox=\"0 3 16 10\"><path d=\"M0,3 L2.01386272,3 L2.01386272,5 L0,5 L0,3 Z M0,11 L2.01386272,11 L2.01386272,13 L0,13 L0,11 Z M0,7 L2.01386272,7 L2.01386272,9 L0,9 L0,7 Z M4,3 L16,3 L16,5 L4,5 L4,3 Z M4,11 L16,11 L16,13 L4,13 L4,11 Z M4,7 L12,7 L12,9 L4,9 L4,7 Z\" id=\"path-1\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/list.svg
// module id = 1295
// module chunks = 0